import { Trans } from 'react-i18next';
import moment from 'moment';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../../lib/helpers';

import useSelectedSpace from '../../../../hooks/useSelectedSpace';

import { ClockIcon } from '../../../../images/shapes';

const TrialEndedPill = ({
  className,
  testId,
}: {
  className: string;
  testId?: string;
}) => {
  const { spaceData } = useSelectedSpace();

  const maxTrialDays = Math.max(
    1,
    moment(spaceData?.paymentDueDate)
      .startOf('day')
      .diff(moment().startOf('day'), 'days'),
  );

  if (spaceData?.paymentStatus !== 'trial') return null;

  return (
    <div
      className={twMerge(
        'flex items-center h-9 px-3 py-1.5 rounded-lg whitespace-nowrap mr-4',
        'font-lg bg-red-50 max-w-max dark:border dark:border-red-600 dark:bg-transparent dark:text-white',
        className,
      )}
      {...getTestProps(testId, 'trial-pill')}
    >
      <ClockIcon className="text-red dark:text-red-600 w-4 h-4 mr-2" />
      <Trans
        i18nKey={'Home.TrialEndsIn'}
        values={{ count: maxTrialDays }}
        components={{ 1: <strong className="px-1" /> }}
      />
    </div>
  );
};

export default TrialEndedPill;
